import { ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import appApi from "@/services/api";
import { exceptionRequestMsg, showToast } from "@/assets/js/util";

export const useTablaTIR = () => {
  return {};
};

export const useTablaTIREditar = () => {
  const router = useRouter()
  const state = ref({
    id: undefined,
    tipo: undefined,
    moneda: undefined,
    rango: undefined,
    plazo: undefined,
    etiqueta: undefined,
    anticipo: undefined,
    tasa: undefined,
    comision: undefined,
    ultima_renta: undefined,
    residual_calculo: undefined,
    buy_out: undefined,
    residual_cliente: undefined,
    opcion_compra: undefined,
    buy_out_oculto: undefined,
    opcion_compra_oculta: undefined,
    tir_objetivo: undefined,
    tir_anterior: undefined,
    diferencias: undefined,
  });
  const cargandoPagina = ref(true);
  const cargando = ref(false);
  const route = useRoute();
  const getDatos = async () => {
    try {
      const resp = await appApi().get(`tablaTIR/${route.params.etiqueta}/edit`);
      state.value = { ...resp.data };
      state.value.anticipo = resp.data.anticipo_number;
      state.value.tasa = resp.data.tasa_number;
      state.value.comision = resp.data.comision_number;
      state.value.residual_calculo = resp.data.residual_calculo_number;
      state.value.buy_out = resp.data.buy_out_number;
      state.value.residual_cliente = resp.data.residual_cliente_number;
      state.value.opcion_compra = resp.data.opcion_compra_number;
      state.value.tir_objetivo = resp.data.tir_objetivo_number;
      state.value.tir_anterior = resp.data.tir_anterior_number;
      cargandoPagina.value = false;
      console.log(state.value);
    } catch (error) {
      exceptionRequestMsg(error);
    }
  };

  const update = async () => {
    cargando.value = true;
    try {
      const resp = await appApi().put(
        `tablaTIR/${route.params.etiqueta}/update`,
        {
          ...state.value,
        }
      );

      console.log(resp);

      showToast(resp.data.message, "success");
      router.push({
        name: "tabla-tir",
      });
    } catch (error) {
      exceptionRequestMsg(error);
    } finally {
      cargando.value = false;
    }
  };

  return {
    cargando,
    cargandoPagina,
    getDatos,
    state,
    update,
  };
};
